import { ModalProvider } from '@leroy-merlin-br/backyard-react'

import reactComponentLoader from 'scripts/react-component-loader'

import BannerContainer from './BannerContainer'

const ComponentBanner = () => (
  <ModalProvider>
    <BannerContainer />
  </ModalProvider>
)

reactComponentLoader(ComponentBanner, '[data-app-banner-install]')
